import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../../services/grupo.service';
import { Grupo } from '../../../models/grupo';

@Component({
  selector: 'app-misdatos',
  templateUrl: './misdatos.component.html',
  styleUrls: ['./misdatos.component.css'],
  providers: [GrupoService]
})
export class MisdatosComponent implements OnInit {
  public identity;
  public token;
  public status;
  public message_success;
  public message_error;
  public grupo: Grupo;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
    this.grupo = new Grupo(1, 1, '', '', '', '', '', '', '', '', 1);
  }

  ngOnInit() {
    this.getGrupo();
  }

  getGrupo() {
    this._grupoService.getGrupo(this.token, this.identity['sub']).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          this.grupo = response.grupo;
        } else {
          alert('No se pueden cargar los datos porque usted no tiene conexión a internet');
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          this.message_error = error;
        }

      }
    );
  }

  actualizar(form) {
    console.log(this.grupo)
    this.status = null
    $(".misdatos").show();
    this._grupoService.actualizar(this.token, this.identity['sub'], this.grupo).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          this.status = response.status;
          this.grupo = response.grupo;
          this.message_success = response.message;
          setTimeout(function () {
            $(".misdatos").fadeTo(500, 1).slideUp(500, function () {
              $(".misdatos").hide();
            });
          }, 3000);
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          this.status = 'error'
          this.message_error = error.error.message
          setTimeout(function () {
            $(".misdatos").fadeTo(500, 1).slideUp(500, function () {
              $(".misdatos").hide();
            });
          }, 3000);
        }
      }
    );
  }

}
